import React from 'react';
import { useOnboarding } from '../context/OnboardingContext';
import { AboutYouSubSteps } from './AboutYouSubSteps';

export const DetailLevelStep: React.FC<{
  onNext: () => void;
}> = ({ onNext }) => {
  const { goToPreviousStep, canGoBack } = useOnboarding();

  return (
    <AboutYouSubSteps
      subStep="detail-level"
      onNext={onNext}
      onBack={goToPreviousStep}
      canGoBack={canGoBack}
    />
  );
};
